const TOPICS = [
  {
    id: 1,
    title: '热血少年',
    desc: '燃爆全场的战斗冒险',
    icon: 'ri-fire-line',
    count: '2,386部',
    color: 'text-red-500',
    bg: 'bg-red-50',
  },
  {
    id: 2,
    title: '甜蜜恋爱',
    desc: '心动不已的浪漫故事',
    icon: 'ri-heart-line',
    count: '1,954部',
    color: 'text-pink-500',
    bg: 'bg-pink-50',
  },
  {
    id: 3,
    title: '悬疑推理',
    desc: '烧脑反转的精彩谜题',
    icon: 'ri-search-eye-line',
    count: '1,203部',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
  },
  {
    id: 4,
    title: '奇幻异界',
    desc: '穿越异世界的冒险之旅',
    icon: 'ri-magic-line',
    count: '1,678部',
    color: 'text-purple-500',
    bg: 'bg-purple-50',
  },
  {
    id: 5,
    title: '搞笑日常',
    desc: '轻松解压的欢乐时光',
    icon: 'ri-emotion-laugh-line',
    count: '1,445部',
    color: 'text-green-500',
    bg: 'bg-green-50',
  },
  {
    id: 6,
    title: '都市职场',
    desc: '现实题材的职场风云',
    icon: 'ri-building-line',
    count: '982部',
    color: 'text-sky-500',
    bg: 'bg-sky-50',
  },
  {
    id: 7,
    title: '古风仙侠',
    desc: '唯美国风的仙侠世界',
    icon: 'ri-brush-line',
    count: '856部',
    color: 'text-teal-500',
    bg: 'bg-teal-50',
  },
  {
    id: 8,
    title: '恐怖灵异',
    desc: '惊悚刺激的灵异故事',
    icon: 'ri-ghost-line',
    count: '634部',
    color: 'text-indigo-500',
    bg: 'bg-indigo-50',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">专题合集</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            精选八大热门漫画专题分类，精准定位你喜爱的漫画类型，韩漫日漫国漫无所不包
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.id}
              href="#index"
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 ${topic.bg} rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <i className={`${topic.icon} text-lg ${topic.color}`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{topic.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{topic.desc}</p>
              <span className="text-xs text-primary-500 font-medium">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}